import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-text-h5 font-bold mb-x1"
}

import LinkHandler from '@/shared/content/blocks/helpers/LinkHandler.vue';
import { LinkModel } from '@/types/B2BcontentServerContract';


export default /*#__PURE__*/_defineComponent({
  __name: 'TransparencyList',
  props: {
    title: null,
    readMoreLabel: null,
    readMoreLink: { default: undefined },
    tag: { default: 'ul' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.title)
      ? (_openBlock(), _createElementBlock("h5", _hoisted_1, [
          _renderSlot(_ctx.$slots, "titleIcon"),
          _createTextVNode(" " + _toDisplayString(__props.title), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent(__props.tag), null, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    })),
    (__props.readMoreLink)
      ? (_openBlock(), _createBlock(LinkHandler, {
          key: 1,
          class: "mt-x2",
          label: __props.readMoreLabel,
          "underline-on-hover": true,
          "show-arrow-icon": true,
          link: __props.readMoreLink
        }, null, 8, ["label", "link"]))
      : _createCommentVNode("", true)
  ]))
}
}

})